import React from 'react';
import VendorModal from 'react-modal';
import classNames from 'classnames';
import {ReactComponent as CloseIcon} from "../../assets/img/close-icon.svg";

import styles from './index.module.scss';

const Modal = (props) => {

  const {onRequestClose, children, className, overlayClassName, sm, ...rest} = props;

  return (

    <VendorModal
      onRequestClose={onRequestClose}
      className={classNames(styles['modal'], className, classNames({
        [styles['modal--sm']] : sm
      }))}
      overlayClassName={classNames(styles['modal-overlay'], overlayClassName)}
      {...rest}
    >

      <button onClick={onRequestClose} className={styles['modal__close-btn']}>
        <CloseIcon/>
      </button>

      {children}

    </VendorModal>
  );

};

export default Modal;
